<template>
  <table class="unstriped hover boss-table">
    <thead>
      <tr>
        <th class="boss-table-head-center">
          フォーマット
        </th>
        <th class="boss-table-head-center">
          記事名
        </th>
        <th class="boss-table-head-center">
          掲載期間
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
      </tr>
    </thead>
    <tbody>
      <job-published-option
        v-for="(option, i) in options"
        :key="i"
        :option="option"
      />
    </tbody>
  </table>
</template>

<script>
import JobPublishedOption from '@/components/molecules/JobPublishedOption'

export default {
  components: {
    JobPublishedOption
  },
  props: {
    options: {
      type: Array,
      required: true
    }
  }
}
</script>
